<div class="armabox">
    <mat-progress-bar class="red-background" *ngIf="mIsLoading" mode="query"></mat-progress-bar>

    <div class="armarow header">
        <div class="red-m-arma-border center-content flexible-content">
            <div class="flexible-element flex-center-content">
                <mat-form-field>
                    <mat-label>{{'Date de début' | translate}}</mat-label>
                    <input [(ngModel)]="mBeginDate" matInput [matDatepicker]="pickerBeginDate" (dateChange)="onDateChange($event)">
                    <mat-datepicker-toggle matSuffix [for]="pickerBeginDate"></mat-datepicker-toggle>
                    <mat-datepicker #pickerBeginDate></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="flexible-element flex-center-content">
                <mat-form-field>
                    <mat-label>{{'Date de fin' | translate}}</mat-label>
                    <input [(ngModel)]="mEndDate" matInput [matDatepicker]="pickerEndDate" (dateChange)="onDateChange($event)">
                    <mat-datepicker-toggle matSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
                    <mat-datepicker #pickerEndDate></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="flexible-element flex-center-content">
                <mat-form-field>
                    <mat-label>{{'Filter per object' | translate}}</mat-label>
                    <mat-select (selectionChange)="updateFilter()" [(ngModel)]="mSelectedObject">
                        <mat-option selected>{{'Peu importe' | translate}}</mat-option>
                        <mat-option *ngFor="let item of mListObject" [value]="item">{{item}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="flexible-element flex-center-content">
                <mat-form-field>
                    <mat-label>{{'Filter per action' | translate}}</mat-label>
                    <mat-select (selectionChange)="updateFilter()" [(ngModel)]="mSelectedAction">
                        <mat-option selected>{{'Peu importe' | translate}}</mat-option>
                        <mat-option *ngFor="let item of mListAction" [value]="item">{{item}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>

    <div class="armarow content">

        <mat-paginator class="center-content" #MatPaginator [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons></mat-paginator>

        <table class="red-m-arma-border mat-elevation-z8 cmat-add-border cmat-red-table-border center-content" mat-table #table [dataSource]="mDataSource">

            <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let row"> {{row.Action}} </td>
            </ng-container>

            <ng-container matColumnDef="Object">
                <th mat-header-cell *matHeaderCellDef> Object </th>
                <td mat-cell *matCellDef="let row"> {{row.ObjectSpy}} </td>
            </ng-container>

            <ng-container matColumnDef="Code">
                <th mat-header-cell *matHeaderCellDef> Code </th>
                <td mat-cell *matCellDef="let row"> {{row.ObjectCode}} </td>
            </ng-container>

            <ng-container matColumnDef="ComputerName">
                <th mat-header-cell *matHeaderCellDef> Computer Name </th>
                <td mat-cell *matCellDef="let row"> {{row.ComputerName}} </td>
            </ng-container>

            <ng-container matColumnDef="ArmaorUserName">
                <th mat-header-cell *matHeaderCellDef> Armaor User </th>
                <td mat-cell *matCellDef="let row"> {{row.ArmaorUserName}} </td>
            </ng-container>

            <ng-container matColumnDef="UnixDate">
                <th mat-header-cell *matHeaderCellDef> Date </th>
                <td mat-cell *matCellDef="let row"> {{toDateJS(row.UnixDate)}} </td>
            </ng-container>

            <ng-container matColumnDef="FileStr">
                <th mat-header-cell *matHeaderCellDef> File </th>
                <td mat-cell *matCellDef="let row"> <!-- {{row.FileStr}} --> </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="mTableHeader; sticky: true;"></tr>
            <tr mat-row *matRowDef="let row; columns: mTableHeader;"></tr>
        </table>
    </div>
</div>
